// export const serverUrl = 'https://palospanas.com:3000';
// export const serverUrl = 'http://157.245.244.236:3005';
export const serverUrl = 'https://dev.palospanas.com:3005';
export const baseUrl = `${serverUrl}/api/v1`;
export const login = `${baseUrl}/auth/login`;
export const clientes = `${baseUrl}/clientes`;
export const peliculas = `${baseUrl}/peliculas`;
export const videos = `${baseUrl}/videos`;
export const archivos = `${baseUrl}/archivos`;
export const archivosFiles = `${archivos}/files`;
export const blog = `${baseUrl}/blog`;
export const blogPublico = `${baseUrl}/blog/publico`;
export const codigos = `${baseUrl}/codigos`;
export const suscripciones = `${baseUrl}/suscripciones`;
export const newsletter = `${baseUrl}/newsletter`;
export const newsletterPublico = `${baseUrl}/newsletter/publico`;
export const tiposBoletin = `${baseUrl}/tipo_boletin`;

export const Token = ({ isToken = true, formData = false }) => {
  const token = localStorage.getItem('PLPtoken');
  const headers = {};

  if (!formData) {
    headers['Content-Type'] = 'application/json';
  }

  if (isToken) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};
